import React, { memo, useEffect, useState } from 'react';
import firebase from 'firebase';
import Section from '../_section';
import MainTitle from '../main-title';
import Carrossel from '../carrossel';
import BookDetail from '../book-detail';
import Review from '../review';
import OthersTitle from '../others-title';
import OthersBooks from '../others-books';
import HeaderLogo from '../../assets/images/new/logo-header.webp'
import Footer from '../footer';
import songsName from '../../enums/songsName';
import { pauseSong, playSong } from '../../utils/song';
import NoAuthModal from '../noauthmodal'
import { FiMenu } from "react-icons/fi"
import DrawerMenu from '../drawer-menu';
import AboutModal from '../about-modal';
import QuestionsModal from '../questions-modal';
import CallUsModal from "../faleconosco/faleconosco-modal";
import ProfileModal from '../profile-modal';
import PaymentModal from '../payment-modal';
import LoginModal from '../login-modal';
import RegistrationModal from '../registration-modal';
import KnowMoreModal from '../know-more';
import TermsOfUse from '../terms-of-use';
import PrivacyPolicy from '../privacy-policy';
import clsx from 'clsx';
import DownloadAppModal from '../download-app-modal';
import { truncateText } from '../../utils/common';
import Author from "../author";

const LandingPage = (props) => {
	const [shouldExpand, setShouldExpand] = useState(true)
	const [showNoAuthModal, setShowNoAuthModal] = useState(false);
	const [isOpenSurprise, setIsOpenSurprise] = useState(null);

	const isAppInitialized = props.appState === 'firsttimevisit' || props.appState === 'landingpage' ? true : false;
	const isLandingPage = props.appState === 'landingpage'

	useEffect(() => {
		if (firebase.messaging.isSupported()) {
			if (window.Notification.permission === 'granted') {
				firebase.messaging().getToken().then(hash => {
					if (hash) console.log('HASH: ', hash);
				});
			}
		}
	}, []);

	// const registerServiceWorker = () => {
	// 	if (firebase.messaging.isSupported()) {
	// 		return navigator.serviceWorker.register('/firebase-messaging-sw.js');
	// 	}
	// }
	
	if (!isAppInitialized) {
		return <div />;
	}

	const changeReader = props.changeReader;

	const onChangeReader = (props) => {
		playSong(songsName.TAP)
		changeReader(props)
	}

	const showExpanded = () => {
		setShouldExpand(true)
	}

	const closeNotExpanded = () => {
    setShouldExpand(false)
	}

	const showLoginModal = () => {
		setShowNoAuthModal(true)
	}

	const getGreetingMessage = () => {
		if (!props.isLoggedIn) return ""

		return "Bem-vindo!"
	}

	return (
		<>
			{/* <PushNotificationModal showEnable={props.appState === 'landingpage'} /> */}

			<Section parent={props}>
				{props.appState === 'landingpage' ? (
					<div
						className={clsx(`header w-full bg-black shadow-md z-30`)}
					>
						<div
							style={{ paddingTop: window.native_app_status_bar_height ?? 16 }}
							className={clsx(`header-background flex flex-row justify-center items-center`)}
						>
							<div className={`w-full flex flex-row max-w-md pb-4 px-6`}>
								<div className='flex flex-1 flex-row items-center'>
									<img src={HeaderLogo} alt='Logo' className='h-7' />
									<h1 className="font-bold text-sm text-white ml-4">
										{getGreetingMessage()}
									</h1>
								</div>

								<button onClick={props.openDrawerHandler}>
									<FiMenu className='w-8 h-8 text-white' />
								</button>
							</div>
						</div>
					</div>
				) : null}

				<DrawerMenu
					isOpened={props.isDrawerOpened}
					close={props.closeDrawerHandler}
					openLoginModal={props.openLoginModalHandler}
					openRegistrationModal={props.openRegistrationModalHandler}
					openAboutModal={props.openAboutModalHandler}
					openQuestionsModal={props.openQuestionsModalHandler}
					openContactUsModal={props.openContactUsModalHandler}
					openProfileModal={props.openProfileModalHandler}
					openPaymentModal={props.openPaymentModalHandler}
					openTermsOfUseModal={props.openTermsOfUseModalHandler}
					openPrivacyPolicyModal={props.openPrivacyPolicyModalHandler}
					openKnowMore={props.openKnowMore}
					logout={props.logout}
					isLoggedIn={props.isLoggedIn}
					isSongDisabled={props.isSongDisabled}
					hasUserASubscription={props.hasUserASubscription}
					toggleBackgroundSong={props.toggleBackgroundSong}
					loginProvider={props.loginProvider}
				/>
				<MainTitle
					isLoggedIn={props.isLoggedIn}
					isOpenSurprise={isOpenSurprise}
					setIsOpenSurprise={setIsOpenSurprise}
					subscriberData={props.subscriberData}
				/>
				<Carrossel
					isOpenSurprise={isOpenSurprise}
					setIsOpenSurprise={setIsOpenSurprise}
					changeToLandingPage={props.changeToLandingPage}
					changeReader={onChangeReader}
					offlineBooksIds={props.offlineBooksIds}
					showExpanded={showExpanded}
					isLoggedIn={props.isLoggedIn}
					openingBookId={props.openingBookId}
					loginProvider={props.loginProvider}
					hasUserASubscription={props.hasUserASubscription}
				/>
				<BookDetail
					handleOpenReader={props.handleOpenReader}
					changeReader={onChangeReader}
					downloadBook={props.downloadBook}
					offlineBooksIds={props.offlineBooksIds}
					downloadingBooksIds={props.downloadingBooksIds}
					showExpanded={showExpanded}
					showLoginModal={showLoginModal}
					isLoggedIn={props.isLoggedIn}
					openingBookId={props.openingBookId}
					loginProvider={props.loginProvider}
					hasUserASubscription={props.hasUserASubscription}
				/>
				<Review />

				<Author />

				<div className={`bg-pallet-2`}>
					<OthersTitle />
					<OthersBooks
						downloadBook={props.downloadBook}
						offlineBooksIds={props.offlineBooksIds}
						downloadingBooksIds={props.downloadingBooksIds}
						lastDownloadedBooksIds={props.lastDownloadedBooksIds}
						openBookFromDownloaded={props.openBookFromDownloaded}
						isLoggedIn={props.isLoggedIn}
						openingBookId={props.openingBookId}
						removeDownloadedBook={props.removeDownloadedBook}
						loginProvider={props.loginProvider}
						hasUserASubscription={props.hasUserASubscription}
					/>
				</div>

				<div
					className='bg-white relative'
					style={{
						paddingBottom: window.native_app_navigation_bar_height ?? 0
					}}
				>
					<div className={"footer_details absolute top-0 left-0"} />
					{/* <InfoButtons appState={props.appState} changeToLogin={props.changeToLogin} /> */}
					{/* <InfoSmallButtons /> */}
					<Footer
						openAboutModal={props.openAboutModalHandler}
						openQuestionsModal={props.openQuestionsModalHandler}
						openContactUsModal={props.openContactUsModalHandler}
					/>
				</div>

				<NoAuthModal
					open={showNoAuthModal}
					changeToLogin={props.openLoginModalHandler}
					onClose={() => setShowNoAuthModal(false)}
				/>

				{
					isLandingPage ? (
						<>
							<ProfileModal isOpened={props.showProfileModal} close={props.closeProfileModalHandler} backToDrawerMenu={props.backToDrawerMenu} subscriberData={props.subscriberData} logout={props.logout} />
							<PaymentModal subscriptionData={props.subscriptionData} isOpened={props.showPaymentModal} close={props.closePaymentModalHandler} backToDrawerMenu={props.backToDrawerMenu} hasUserASubscription={props.hasUserASubscription} checkIfUserHasScubscription={props.checkIfUserHasScubscription} subscriberData={props.subscriberData} isUserInFreeTrial={props.isUserInFreeTrial} />
							<AboutModal isOpened={props.showAboutModal} close={props.closeAboutModalHandler} backToDrawerMenu={props.backToDrawerMenu} />
							<QuestionsModal isOpened={props.showQuestionsModal} close={props.closeQuestionsModalHandler} backToDrawerMenu={props.backToDrawerMenu} />
							<KnowMoreModal isOpened={props.showKnowMore} close={props.closeKnowMore} backToDrawerMenu={props.backToDrawerMenu} />
							<TermsOfUse isOpened={props.showTermsOfUse} close={props.closeTermsOfUseModalHandler} backToDrawerMenu={props.backToDrawerMenu} />
							<PrivacyPolicy isOpened={props.showPrivacyPolicy} close={props.closePrivacyPolicyModalHandler} backToDrawerMenu={props.backToDrawerMenu} />

							<LoginModal isOpened={props.showLoginModal} close={props.closeLoginModalHandler} openRegistration={props.openRegistrationFromLoginModal} onLoginSuccess={props.onLoginSuccess} onPortfolioLoaded={props.onPortfolioLoaded} updateSubscriberData={props.updateSubscriberData} updateLoginProvider={props.updateLoginProvider} backToDrawerMenu={props.backToDrawerMenu} />
							<RegistrationModal isOpened={props.showRegistrationModal} close={props.closeRegistrationModalHandler} openLogin={props.openLoginFromRegistrationModal} backToDrawerMenu={props.backToDrawerMenu} />

							<CallUsModal
								show_callus={props.showContactUsModal}
								toggle_callus={props.closeContactUsModalHandler}
								appState={props.appState}
								backToDrawerMenu={props.backToDrawerMenu}
							/>
						</>
					) : null
				}

				<DownloadAppModal
					opened={shouldExpand}
					close={() => setShouldExpand(false)}
				/>

				{/* <AdsModal
					open={showAdsModal}
					onRequestClose={setShowAdsModal}
					changeToLandingPage={props.changeToLandingPage}
				/> */}
			</Section>
		</>
	);
};

export default memo(LandingPage);
